import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { toast } from 'sonner';

const Login = () => {
  const { t } = useLanguage();
  const { login } = useAuth();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(formData.email, formData.password);
      toast.success('Logged in successfully');
      navigate('/');
    } catch (error) {
      toast.error('Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F9F7] pt-32 pb-24 flex items-center justify-center" data-testid="login-page">
      <div className="max-w-md w-full px-6">
        <h1 className="text-xs font-sans font-bold tracking-tight text-[#1A1A1A] mb-8 text-center uppercase">
          {t('signIn')}
        </h1>

        <form onSubmit={handleSubmit} className="space-y-6" data-testid="login-form">
          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-[#1A1A1A] mb-2 block">
              {t('emailAddress')}
            </label>
            <input
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              required
              className="w-full bg-transparent border-b border-[#1A1A1A]/20 focus:border-[#1A1A1A] py-3 px-0 text-[#1A1A1A] placeholder:text-[#1A1A1A]/40 focus:ring-0 focus:outline-none transition-colors"
              data-testid="email-input"
            />
          </div>

          <div>
            <label className="text-xs uppercase tracking-[0.2em] text-[#1A1A1A] mb-2 block">
              {t('password')}
            </label>
            <input
              type="password"
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              required
              className="w-full bg-transparent border-b border-[#1A1A1A]/20 focus:border-[#1A1A1A] py-3 px-0 text-[#1A1A1A] placeholder:text-[#1A1A1A]/40 focus:ring-0 focus:outline-none transition-colors"
              data-testid="password-input"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-[#1A1A1A] text-white px-8 py-4 text-xs uppercase tracking-[0.2em] hover:bg-[#333333] transition-all duration-300 disabled:opacity-50"
            data-testid="login-submit-btn"
          >
            {loading ? 'Loading...' : t('signIn')}
          </button>
        </form>

        <p className="text-center text-sm text-[#8A8A8A] mt-6">
          {t('dontHaveAccount')}{' '}
          <Link to="/register" className="text-[#1A1A1A] underline underline-offset-4 hover:text-[#C6A87C] transition-colors" data-testid="register-link">
            {t('signUp')}
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Login;